import React from 'react';
import {
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  Box,
  Typography,
  useTheme,
  alpha
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { ApiKey } from '../services/ApiKeysService';

const ApiKeyRow: React.FC<{
  apiKey: ApiKey;
  onToggleStatus: (apiKey: ApiKey) => void;
  formatDate: (date: string) => string;
}> = React.memo(({ apiKey, onToggleStatus, formatDate }) => {
  const theme = useTheme();

  return (
    <TableRow
      hover
      sx={{
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: `${alpha(theme.palette.primary.light, 0.08)} !important`,
          transform: 'translateY(-1px)'
        }
      }}
    >
      <TableCell sx={{ display: { xs: 'none', md: 'table-cell' }, color: 'text.secondary' }}>
        {apiKey.id}
      </TableCell>
      <TableCell>
        <Typography variant="body1" fontWeight={500} sx={{ color: theme.palette.primary.main }}>
          {apiKey.name}
        </Typography>
      </TableCell>
      <TableCell align="center">
        {apiKey.active ? (
          <Tooltip title="Active">
            <Box sx={{ display: 'inline-flex' }}>
              <CheckCircleIcon
                color="success"
                sx={{
                  filter: 'drop-shadow(0px 1px 2px rgba(0,0,0,0.1))',
                  transition: 'all 0.2s',
                  '&:hover': {
                    transform: 'scale(1.1)'
                  }
                }}
              />
            </Box>
          </Tooltip>
        ) : (
          <Tooltip title="Inactive">
            <Box sx={{ display: 'inline-flex' }}>
              <CancelIcon
                color="error"
                sx={{
                  filter: 'drop-shadow(0px 1px 2px rgba(0,0,0,0.1))',
                  transition: 'all 0.2s',
                  '&:hover': {
                    transform: 'scale(1.1)'
                  }
                }}
              />
            </Box>
          </Tooltip>
        )}
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {formatDate(apiKey.createDate)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {formatDate(apiKey.updateDate)}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip title={apiKey.active ? 'Deactivate' : 'Activate'}>
            <IconButton
              onClick={() => onToggleStatus(apiKey)}
              color={apiKey.active ? 'warning' : 'success'}
              sx={{
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: alpha(
                    apiKey.active ? theme.palette.warning.main : theme.palette.success.main,
                    0.1
                  ),
                  transform: 'scale(1.1)'
                }
              }}
            >
              <PowerSettingsNewIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </TableCell>
    </TableRow>
  );
});

export default ApiKeyRow;
